import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/arrival/platform`;

// Summary + per-customer rows for a round (read-only, no send).
const getPlatformArrivalSummary = async ({ shipDateId, shop }) => {
  return await axios.post(`${BASE}/summary`, { shipDateId, shop });
};

// Broadcast via Chatcone to an explicit list of customers. Backend skips anyone
// already 'sent' unless force=true.
const broadcastPlatformArrival = async ({ shipDateId, shop, customerIds, force = false }) => {
  return await axios.post(`${BASE}/broadcast`, { shipDateId, shop, customerIds, force });
};

// Manual fallback: send the explicit list via direct LINE (e.g. Chatcone down).
const sendPlatformArrivalViaLine = async ({ shipDateId, shop, customerIds, force = false }) => {
  return await axios.post(`${BASE}/send-line`, { shipDateId, shop, customerIds, force });
};

export default {
  getPlatformArrivalSummary,
  broadcastPlatformArrival,
  sendPlatformArrivalViaLine,
};
